import { useContext } from 'react';

import { FormParserContext } from 'src/contexts/form.context';
import { InputContext } from 'src/contexts/input.context';
import { CompaniesAutoComplete as CompaniesAutoCompleteComponent } from 'src/components/InputRenderers/CompaniesAutoComplete';
import { AutoCompleteResult, Maybe } from 'src/models';
import { ifTrue } from 'src/tools/logic.tools';

interface Props {
  isProject?: boolean;
}

export function CompaniesAutoComplete({ isProject }: Props) {
  const {
    value,
    script,
    onChange,
    writeData = [],
    readData: companyName,
    actions,
    isDisabled,
    error,
  } = useContext(FormParserContext);

  const [setCompanyName] = writeData;

  function handleOnChange(result: Maybe<AutoCompleteResult>) {
    onChange(result?.id);

    if (setCompanyName) setCompanyName(result?.label);
  }

  function renderAutoComplete() {
    return (
      <InputContext.Provider
        value={{
          classNames: { container: 'w-100p', input: ifTrue(error, 'with-error') },
          value,
          data: companyName,
          onChange: handleOnChange,
          isDisabled: script.isDisabled || isDisabled,
          isAutoFocus: script.autofocus,
          placeholder: script.placeholder,
          customization: {
            addNew: script.addNew,
          },
          actions: {
            onChangeInput: setCompanyName,
            onAddCompany: actions?.addCompany,
          },
        }}
      >
        <CompaniesAutoCompleteComponent isProject={isProject} />
      </InputContext.Provider>
    );
  }

  return <div className='w-100p column items-p8'>{renderAutoComplete()}</div>;
}
